import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {QsChecksControllingHomePage} from './qs-checks-controlling-home.page';
import {TranslateModule} from '@ngx-translate/core';
import {EffectsModule} from '@ngrx/effects';
import {SopiScrollModule} from '../../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {StoreModule} from '@ngrx/store';
import {reducers} from './qs-checks-controlling-home.reducer';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {
   QschecksSaisonUebersichtEffects, QschecksSaisonUebersichtExcelEffects
} from '../../../../client-ngrx/qschecks';
import {QsChecksControllingHomeUiEffects} from './qs-checks-controlling-home.effects.ui';
import {QsChecksControllingHomeEffectsWs} from './qs-checks-controlling-home.effects.ws';

const routes: Routes = [
    {
        path: '',
        component: QsChecksControllingHomePage,
        data: {title: 'QS Checks Controlling Home'}
    },
    {
        path: 'saison-filter',
        children: [
            {
                path: '',
                loadChildren: () => import( '../qschecks-controlling-saison-filter/qschecks-controlling-saison-filter.module').then(m => m.QschecksControllingSaisonFilterPageModule)
            }
        ]
    },
    {
        path: 'veranstaltung',
        children: [
            {
                path: '',
                loadChildren: () => import( '../qs-checks-controlling-veranstaltung/qs-checks-controlling-veranstaltung.module').then(m => m.QsChecksControllingVeranstaltungPageModule)
            }
        ]
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule,
        StoreModule.forFeature('QsChecksControllingHomePage', reducers),
        EffectsModule.forFeature([
            QsChecksControllingHomeUiEffects,
            QsChecksControllingHomeEffectsWs,

            QschecksSaisonUebersichtEffects,
            QschecksSaisonUebersichtExcelEffects
        ]),
        SopiScrollModule,
        DragDropModule,
        SopiComponentsModule.forRoot()
    ],
    declarations: [QsChecksControllingHomePage],
    entryComponents: [QsChecksControllingHomePage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class QsChecksControllingHomePageModule {
}
